import _ from 'lodash'
import Initialize from '@patsnap-utils/passport'
import { baseAuthServer, clientId, clientName, codes } from './constants'
import { UserCenterService, config } from '@patsnap-utils/biz'
import { ACCOUNT_URI_ENVIRONMENT, NO_REDIRECT } from '@/infrastructure/utils/environment'
import '@patsnap-biz/design-tokens/scss/_variables-IP.css';
import { RavenInsertMeta } from '@/tracer'
import qs from 'qs'

config.clientId = clientId
config.clientName = clientName

window.debugMap = new WeakMap();

const initialize = Initialize({
    clientId,
    baseAuthServer,
    clientName,
    // storeKeyPrefix: 'TOKEN',
    accessTokenExpiredMS: 25 * 60 * 1000,
    refreshTokenExpiredMS: 115 * 60 * 1000,
    autoRun: true,
    redirectToLogin(error) {
        const errcode = _.get(error, 'errcode', '39999');

        const logoutHref = UserCenterService.createLogoutHref(true, {
            errcode,
        })
        if (NO_REDIRECT) {
            console.error('redirect to', logoutHref)
            return
        }
        window.location.href = logoutHref
    },
    onTokenRefresh(error) {
        window.postMessage('onTokenRefresh', window.location.href.split('#')[0])
        const { numeric_error_code: code } = (error as any).response.data
        if (code !== 20109 && codes.includes(code)) {
            throw new Error('Cannot request again, or it will lead to endless loop. All in plan.')
        }
    },
    detectResponseAsUnauthorized: e => {
        const codes = [20109]
        if (e && e.response) {
            const {
                status,
                data,
            } = e.response
            if (status === 401) {
                return true
            }
            if (data) {
                const { numeric_error_code: code } = data
                return codes.includes(code)
            }
        }
        return false
    },
    // MFA 多因素认证相关错误处理
    async onMfaRequired(err) {
        // 处理MFA验证失败的情况
        // MFA错误通常在HTTP 403状态码下出现
        // 例如：跳转到MFA验证页面或显示MFA绑定提示
        const urlParams = {
            from: clientName,
            client_id: clientId,
            redirect_uri: encodeURIComponent(window.location.href),
            errorCode: _.get(err, 'errcode'),
        }
        const url = `${ACCOUNT_URI_ENVIRONMENT}/user-settings/#/mfa-required${qs.stringify(urlParams, { addQueryPrefix: true })}`
        window.location.replace(url);
    },

})

window.rvTrack = (action, attribute, moduleName = 'Admin') => {
    if (RavenInsertMeta) {
        RavenInsertMeta(moduleName, action, attribute);
    }
};

Promise.all([initialize, import(/* webpackChunkName: "entry" */ './config')])
    .then(([passport, { default: application }]) => {
        // @ts-ignore
        window._passport = passport
        return application()
    })
